import styled from 'styled-components';

/* Normal in-flow nav wrapper — just handles the fade-in opacity */
export const NavOuterWrapper = styled.div`
    /* opacity driven by inline style on mount */
`;

export const NavContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: var(--space-12) var(--space-6) 14px;

    @media (max-width: 768px) {
        padding: 14px var(--space-6);
    }
`;

/* Pill nav group — sits inside the normal nav on desktop */
export const PillNavGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    background: ${({ theme }) => theme.altWhite};
    border-radius: var(--radius-pill);
    padding: 5px 6px;

    @media (max-width: 768px) {
        display: none;
    }
`;

/*
 * Floating pill — always position:fixed at top-center.
 * Hidden (opacity 0, slight upward shift) until $scrolled is true.
 * Only shown on desktop.
 */
export const FloatingPill = styled.div`
    position: fixed;
    top: var(--space-4);
    left: 50%;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 2px;
    background: ${({ theme }) => theme.altWhite};
    border-radius: var(--radius-pill);
    padding: 5px 6px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08),
                0 2px 8px  rgba(0, 0, 0, 0.06),
                0 0 0 1px  ${({ theme }) => theme.outline};

    /* Scroll-driven visibility */
    opacity:        ${({ $scrolled }) => $scrolled ? 1 : 0};
    pointer-events: ${({ $scrolled }) => $scrolled ? 'auto' : 'none'};
    transform: translateX(-50%) translateY(${({ $scrolled }) => $scrolled ? '0' : '-10px'});

    transition:
        opacity   0.35s ease,
        transform 0.4s  cubic-bezier(0.16, 1, 0.3, 1);

    @media (max-width: 768px) {
        display: none;
    }
`;

/* Spacer — no longer needed (nav is in flow) but kept for any legacy import */
export const NavSpacer = styled.div`
    display: none;
`;

/* Floating bottom nav — mobile only */
export const MobileBottomBar = styled.nav`
    display: none;

    @media (max-width: 768px) {
        display: flex;
        align-items: center;
        position: fixed;
        bottom: var(--space-6);
        padding-bottom: env(safe-area-inset-bottom);
        left: 50%;
        transform: translateX(-50%);
        background: ${({ theme }) => theme.altWhite};
        border-radius: var(--radius-pill);
        padding: 6px;
        gap: 2px;
        box-shadow:
            0 0 0 1px  rgba(0, 0, 0, 0.08),
            0 8px 32px rgba(0, 0, 0, 0.18),
            0 2px 8px  rgba(0, 0, 0, 0.10);
        z-index: 9999;
        white-space: nowrap;
    }
`;

export const NavSayHello = styled.a`
    display: flex;
    align-items: center;
    gap: 7px;
    background: var(--color-primary);
    color: #ffffff;
    padding: 9px 18px;
    border-radius: var(--radius-pill);
    font-family: var(--font-ui);
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -0.01em;
    text-decoration: none;
    flex-shrink: 0;
    transition: opacity 0.15s ease;
    &:hover { opacity: 0.8; }
`;

export const NavLinkedIn = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    color: var(--color-heading);
    border: 1px solid rgba(17, 19, 24, 0.16);
    width: 38px;
    height: 38px;
    border-radius: var(--radius-pill);
    text-decoration: none;
    flex-shrink: 0;
    transition: opacity 0.15s ease;
    &:hover { opacity: 0.8; }
`;

export const NavBottomPillInactive = styled.span`
    color: ${({ theme }) => theme.textMain};
`;

/* kept for any legacy imports */
export const NavCont  = styled.nav``;
export const NavLinks = styled.div``;
export const Spread   = styled.div``;
